import type { RouteParams } from '#vue-router'

export function useRouteParams(): RouteParams {
  return useRoute().params
}
